"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return SMTP;
    }
});
const _nodemailer = /*#__PURE__*/ _interop_require_default(require("nodemailer"));
const _ncError = require("~/helpers/ncError");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let SMTP = class SMTP {
    async init() {
        var _this_input, _this_input1, _this_input2, _this_input3, _this_input4, _this_input5, _this_input6, _this_input7, _this_input8, _this_input9, _this_input10, _this_input11, _this_input12, _this_input13, _this_input14, _this_input15, _this_input16, _this_input17;
        const config = _extends({
            name: (_this_input = this.input) == null ? void 0 : _this_input.name,
            host: (_this_input1 = this.input) == null ? void 0 : _this_input1.host,
            port: parseInt((_this_input2 = this.input) == null ? void 0 : _this_input2.port, 10),
            secure: typeof ((_this_input3 = this.input) == null ? void 0 : _this_input3.secure) === 'boolean' ? (_this_input4 = this.input) == null ? void 0 : _this_input4.secure : ((_this_input5 = this.input) == null ? void 0 : _this_input5.secure) === 'true',
            ignoreTLS: typeof ((_this_input6 = this.input) == null ? void 0 : _this_input6.ignoreTLS) === 'boolean' ? (_this_input7 = this.input) == null ? void 0 : _this_input7.ignoreTLS : ((_this_input8 = this.input) == null ? void 0 : _this_input8.ignoreTLS) === 'true',
            tls: {
                rejectUnauthorized: typeof ((_this_input9 = this.input) == null ? void 0 : _this_input9.rejectUnauthorized) === 'boolean' ? (_this_input10 = this.input) == null ? void 0 : _this_input10.rejectUnauthorized : ((_this_input11 = this.input) == null ? void 0 : _this_input11.rejectUnauthorized) === 'true'
            }
        }, ((_this_input12 = this.input) == null ? void 0 : _this_input12.username) || ((_this_input13 = this.input) == null ? void 0 : _this_input13.password) ? {
            auth: _extends({}, ((_this_input14 = this.input) == null ? void 0 : _this_input14.username) ? {
                user: (_this_input15 = this.input) == null ? void 0 : _this_input15.username
            } : {}, ((_this_input16 = this.input) == null ? void 0 : _this_input16.password) ? {
                pass: (_this_input17 = this.input) == null ? void 0 : _this_input17.password
            } : {})
        } : {});
        this.transporter = _nodemailer.default.createTransport(config);
    }
    async mailSend(mail) {
        if (this.transporter) {
            await this.transporter.sendMail(_extends({}, mail, {
                from: this.input.from
            }));
        }
    }
    async test() {
        try {
            await this.mailSend({
                to: this.input.from,
                subject: 'Test email',
                html: 'Test email'
            });
            return true;
        } catch (e) {
            console.log('SMTP test error :: ', e);
            _ncError.NcError.pluginTestError(e == null ? void 0 : e.message);
        }
    }
    constructor(input){
        this.input = input;
    }
};
